import { makeStyles } from "tss-react/mui"
import { DialogContent, Stack, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"
import { UserType } from "../../../../modules/login/loginTypes"
import { StandardButton } from "../../buttons/StandardButton"
import { StandardDialog } from "../../dialogs/StandardDialog"
import { OnBehalfCompletedDialog } from "../hooks/useCreateOrderUser"
import { CreateOrderType } from "../helpers"

const useStyles = makeStyles()((theme) => ({
    dialogContent: {
        padding: "2.5rem",
        paddingTop: "1rem",
        display: "flex",
        gap: "2rem",
        flexDirection: "column",
        margin: "0 auto",
        color: theme.palette.tailwind.slate[950],
    },
}))

type InvalidUserPermissionsDialogProps = Readonly<{
    isOnBehalfCompleted: OnBehalfCompletedDialog
    activeOrderTab?: CreateOrderType
    handleClose: () => void
    handleShowOrderOnBehalfDialog: () => void
}>

export function InvalidUserPermissionsDialog({
    isOnBehalfCompleted,
    activeOrderTab,
    handleClose,
    handleShowOrderOnBehalfDialog,
}: InvalidUserPermissionsDialogProps) {
    const { classes } = useStyles()
    const { userType, displayName } = isOnBehalfCompleted

    const isMerchant = userType === UserType.MERCHANT
    const isUser = userType == UserType.USER
    const isMeetingService = activeOrderTab === CreateOrderType.MEETING_SERVICE
    const isResourceBooking = activeOrderTab === CreateOrderType.RESOURCE_BOOKING

    const bodyTranslationId =
        isMerchant && isMeetingService
            ? "create-order-invalid-user-permissions-merchant-meeting-service-dialog-body"
            : isMerchant && isResourceBooking
              ? "create-order-invalid-user-permissions-merchant-resource-booking-dialog-body"
              : "create-order-tabs-error-body"

    const bodyVars = isMerchant && (isMeetingService || isResourceBooking) ? { displayName } : undefined

    const bodyElements =
        isMerchant && (isMeetingService || isResourceBooking)
            ? {
                  displayName: (
                      <Typography component="span" fontWeight="bold">
                          {displayName}
                      </Typography>
                  ),
              }
            : undefined

    return (
        <StandardDialog
            dialogTitle={
                <LocalizedStrict id="create-order-tabs-error">
                    <>You can't place an order</>
                </LocalizedStrict>
            }
            open={true}
            onClose={() => {}}
            hideCloseIcon
            maxWidthProp="sm"
            scroll="body"
        >
            <DialogContent className={classes.dialogContent}>
                <LocalizedStrict id={bodyTranslationId} vars={bodyVars} elems={bodyElements}>
                    <Typography variant="body1" textAlign="center">
                        You can't place an order because your account doesn't have the required access. Please contact
                        support if you need more information.
                    </Typography>
                </LocalizedStrict>
                <Stack flexDirection="row" gap="1rem" justifyContent="center">
                    <LocalizedStrict id="create-order-tabs-error-dialog-close-button">
                        <StandardButton color="grey" variant="outlined" fullWidth={!isUser} onClick={handleClose}>
                            Go back
                        </StandardButton>
                    </LocalizedStrict>
                    {!isUser && (
                        <LocalizedStrict id="create-order-tabs-error-dialog-confirm-button">
                            <StandardButton onClick={handleShowOrderOnBehalfDialog}>Select another user</StandardButton>
                        </LocalizedStrict>
                    )}
                </Stack>
            </DialogContent>
        </StandardDialog>
    )
}
